import React, { Component } from 'react';
import './index.scss';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';
import MemberCardLogin from './MemberCardLogin';
import PhoneNumberLogin from './PhoneNumberLogin';
import EmailLogin from './EmailLogin';
import { Modal } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2';
import { showAlert } from '../showAlert';

export class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      barcodeModalSH: false,
      layoutName: '',
      memberCardNumber: '',
      scanBarCodeBtnClick: false,
      manualBarCodeBtnClick: false,
      keyboardInputClickManually: false,
      loginErrorMsg: '',
      scanBarcodeLoaderMsg: 'Barcode scanning in progress',
      loginType: '',
      activeKeyboard: '',
      phoneNumber: '',
      showPhoneLoginModal: false,
      email: '',
      showUsersChoiceModal: false,
      canHaveMultipleUsers: JSON.parse(window.constant.LOGIN_MODULE).find(item => item.loginType === 'phonenumber')?.options?.canHaveMultipleUsers === 'true',
      selectedUserAccount: '',
      usersList: [],
      useLoginModal: JSON.parse(window.constant.LOGIN_MODULE).find(item => item.loginType === 'phonenumber')?.options?.useLoginModal === 'true',
    };
  }

  componentDidMount = async () => {
    // window.winvar = this;
    localStorage.removeItem('endTimeInSecs');
    localStorage.removeItem('BookingCountdown');

    let orderType = localStorage.getItem('orderType');
    if (localStorage.getItem('orderId') != null && orderType == 'fnb' && localStorage.getItem('giftCardSwipeInit') != null) {
      var orderDetails = JSON.parse(localStorage.getItem('orderId'));
      if (orderDetails?.id) {
        localStorage.removeItem('giftCardSwipeInit');
        window.callbackObj.callAbortTransaction(orderDetails.id, 'failure', 'Sorry', 'Swipe cancelled');
      }

      this.deleteOrder();
      localStorage.removeItem('orderId');
    }
  };

  componentDidUpdate = (prevProps, prevState) => {};

  handleLoginTypeChange = type => {
    this.setState({
      loginType: type,
      activeKeyboard: type,
    });
  };

  handleKeyboardToggle = type => {
    this.phoneRef?.closeKeyboard();
    this.emailRef?.closeKeyboard();
    this.resetErrorMsg();

    if (type === 'phone') {
      this.emailChange('');
      this.phoneRef?.openKeyboard();
    } else if (type === 'email') {
      this.phoneNumberChange('');
      this.emailRef?.openKeyboard();
    }
  };

  deleteOrder = () => {
    var orderDetails = JSON.parse(localStorage.getItem('orderId'));
    if (orderDetails?.id) {
      API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
        .then(response => {
          console.log(response);
        })
        .catch(ex => {
          console.log(ex.error);
        });
    }
  };

  guestUser = async () => {
    // When session expiry in login user > delete order
    if (window.constant.ENABLE_VOUCHERS == 'true') {
      window.location.href = `/addvouchers`;
    } else {
      if (localStorage.getItem('sessionExpiredRedirectUrl') != null && localStorage.getItem('orderId') != null) {
        this.setState({
          loader: true,
        });
        var orderDetails = JSON.parse(localStorage.getItem('orderId'));
        await API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
          .then(response => {
            localStorage.removeItem('selectedSeats');
            localStorage.removeItem('orderId');
            localStorage.removeItem('cartData');
            localStorage.removeItem('sessionExpiredRedirectUrl');
            this.setState({ loader: false });
          })
          .catch(err => {
            console.log(err.error, 'delete error');
            this.setState({ loader: false });
          });
      }

      const isFnbFlow = localStorage.getItem('orderType') === 'fnb';
      const cinemaId = localStorage.getItem('cinemaid');
      if (isFnbFlow) {
        window.location.href = `fnb?cinemaid=${cinemaId}`;
      } else {
        var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
        window.location.href = `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;
      }
    }
  };

  phoneNumberChange = phoneNumber => {
    this.setState({ phoneNumber });
  };

  emailChange = email => {
    this.setState({ email });
  };

  moveToNextPage = () => {
    let orderType = localStorage.getItem('orderType');
    if (orderType == 'ticketing') {
      var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
      var redirectURL = window.constant.ENABLE_VOUCHERS == 'true' ? '/addvouchers' : `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;

      window.location.href = redirectURL;
    } else {
      var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
      var redirectURL = window.constant.ENABLE_VOUCHERS == 'true' ? '/addvouchers' : `/fnb?cinemaid=${getCinemaIdFromLocalstorage}`;

      window.location.href = redirectURL;
    }
  };

  validateEmail = email => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  disableContinueBtn = () => {
    let disabled = true;
    if (this.state.phoneNumber.length == 10 || this.validateEmail(this.state.email)) {
      disabled = false;
    }
    return disabled;
  };

  resetErrorMsg = () => {
    this.setState({
      loginErrorMsg: '',
    });
  };

  loginByPhoneAndEmail = () => {
    let loginType = this.state.phoneNumber.length == 10 ? 'phoneNumber' : 'email';
    this.setState(
      {
        loader: true,
        loginErrorMsg: '',
      },
      () => {
        var data = new Object();
        if (loginType === 'phoneNumber') {
          data.phoneNumber = this.state.phoneNumber;
        } else {
          data.email = this.state.email;
        }

        API.userLogin(loginType, data)
          .then(response => {
            document.cookie = 'accessToken=' + response.data.accessToken;
            document.cookie = 'refreshToken=' + response.data.refreshToken;
            document.cookie = 'phonenumber=' + response.data.phonenumber;
            document.cookie = 'email=' + response.data.email;
            document.cookie = 'firstname=' + response.data.firstname;
            document.cookie = 'lastname=' + response.data.lastname;

            this.moveToNextPage();
          })
          .catch(ex => {
            console.log(ex.error);

            if (loginType === 'phoneNumber') {
              const loginModules = JSON.parse(window.constant.LOGIN_MODULE);
              const checkPhoneErrorType = loginModules.find(module => module.loginType === 'phonenumber');
              const { showError } = checkPhoneErrorType.options;

              if (showError === 'true') {
                this.setState({
                  loader: false,
                  loginErrorMsg: ex.error ? ex.error : 'Something went wrong. Please try again or contact support.',
                });
              } else {
                this.setState({
                  loader: false,
                });
                document.cookie = 'guestphonenumber=' + this.state.phoneNumber;
                this.guestUser();
              }
            } else {
              this.setState({
                loader: false,
                loginErrorMsg: ex.error ? ex.error : 'Something went wrong. Please try again or contact support.',
              });
            }
          });
      }
    );
  };

  loginMemberCard = async () => {
    // console.log(this.state.selectedUserAccount, "selectedUserAccount, loginMembercard");
    if (this.state.selectedUserAccount.length < 1) return;
    this.setState({ loader: true });
    await API.userLogin('cardNumber', {
      cardNumber: this.state.selectedUserAccount,
    })
      .then(res => {
        document.cookie = 'accessToken=' + res.data.accessToken;
        document.cookie = 'refreshToken=' + res.data.refreshToken;
        document.cookie = 'phonenumber=' + res.data.phonenumber;
        document.cookie = 'email=' + res.data.email;
        document.cookie = 'firstname=' + res.data.firstname;
        document.cookie = 'lastname=' + res.data.lastname;
        this.setState({ loader: false });
        var getSessionExpiredRedirectUrl = localStorage.getItem('sessionExpiredRedirectUrl');

        if (getSessionExpiredRedirectUrl == null) {
          let orderType = localStorage.getItem('orderType');
          if (orderType == 'ticketing') {
            console.log('ticketing flow');
            var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
            var redirectURL = window.constant.ENABLE_VOUCHERS == 'true' ? '/addvouchers' : `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;
            window.location.href = redirectURL;
          } else {
            console.log('fnb flow');
            var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
            var redirectURL = window.constant.ENABLE_VOUCHERS == 'true' ? '/addvouchers' : `/fnb?cinemaid=${getCinemaIdFromLocalstorage}`;
            // console.log('fnb flow > redirectURL: ', redirectURL);
            window.location.href = redirectURL;
          }
        } else {
          // login user -- Session expired time
          // console.log('Login expiry flow');
          window.location.href = getSessionExpiredRedirectUrl;
        }
      })
      .catch(err => {
        this.setState({ showUsersChoiceModal: false });
        showAlert({
          html: `<p>Sorry<span>${err?.error}</span></p>`,
          iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
          showCancelButton: false,
          cancelButtonText: '',
          showConfirmButton: true,
          confirmButtonText: 'Close',
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          popupClasses: 'common-error-alert',
          onConfirm: () => {},
          onCancel: () => {},
        });
      })
      .finally(() => this.setState({ loader: false }));
  };

  handlePhoneNumberLogin = async () => {
    if (this.state.canHaveMultipleUsers && this.state.phoneNumber.length == 10) {
      this.setState({ loader: true });
      await API.callEndpoint('POST', 'Bearer', '/user/v2/users/search', {
        phoneNumber: this.state.phoneNumber,
      })
        .then(async res => {
          // console.log(res.data, "testing users data");
          if (res.data.length < 1) {
            showAlert({
              html: `<p>Sorry<span>No Users found</span></p>`,
              iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
              showCancelButton: false,
              cancelButtonText: '',
              showConfirmButton: true,
              confirmButtonText: 'Close',
              allowOutsideClick: false,
              allowEscapeKey: false,
              iconClasses: 'borderless',
              popupClasses: 'common-error-alert',
              onConfirm: () => {
                this.phoneRef?.closeKeyboard();
                this.resetErrorMsg();
                this.phoneNumberChange('');
              },
              onCancel: () => {},
            });
          }

          if (res.data.length === 1) {
            this.setState(
              {
                selectedUserAccount: res.data[0].cardNumber,
              },
              async () => {
                await this.loginMemberCard();
              }
            );
          } else {
            this.setState({ usersList: res.data, showUsersChoiceModal: true, loader: false, showPhoneLoginModal: false });
          }

          this.phoneRef?.closeKeyboard();
          this.resetErrorMsg();
        })
        .catch(err => {
          console.log(err, 'error');
          showAlert({
            html: `<p>Sorry<span>${err?.error}</span></p>`,
            iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
            showCancelButton: false,
            cancelButtonText: '',
            showConfirmButton: true,
            confirmButtonText: 'Close',
            allowOutsideClick: false,
            allowEscapeKey: false,
            iconClasses: 'borderless',
            popupClasses: 'common-error-alert',
            onConfirm: () => {
              this.phoneRef?.closeKeyboard();
              this.resetErrorMsg();
              this.phoneNumberChange('');
            },
            onCancel: () => {},
          });
        })
        .finally(() => this.setState({ loader: false }));
    } else {
      // console.log("else called handlePhoneNumberLogin");
      this.loginByPhoneAndEmail();
    }
  };

  updatedParentState = data => {
    this.setState(data);
  };

  render() {
    const renderedLoginTypes = [];
    const loginModules = JSON.parse(window.constant.LOGIN_MODULE);
    const dynamicComponent = loginModules.find(module => module.loginType === 'dynamicComponent' && module.isActive === 'true');
    const activeModules = loginModules.filter(item => item.isActive === 'true');

    if (dynamicComponent && dynamicComponent.hasOwnProperty('loginTypes')) {
      loginModules.forEach(module => {
        if (dynamicComponent.loginTypes.includes(module.loginType)) {
          renderedLoginTypes.push(module);
        }
      });
    } else {
      renderedLoginTypes.push(...activeModules);
    }

    let checkIfContinueBtnRequired = renderedLoginTypes.filter(item => item.loginType == 'phonenumber' || item.loginType == 'email').length > 0 && !this.state.useLoginModal;
    return (
      <React.Fragment>
        <Loader loader={this.state.loader} />
        <section className="content">
          <div className="loginComponent">
            {renderedLoginTypes.map(module => {
              if (module.loginType === 'membercard') {
                return (
                  <MemberCardLogin
                    key="membercard"
                    timerIncrement={this.props.timerIncrement}
                    timerDecrement={this.props.timerDecrement}
                    dynamicComponent={dynamicComponent ? true : false}
                    handleKeyboardToggle={this.handleKeyboardToggle}
                  />
                );
              }
              if (module.loginType === 'phonenumber') {
                return (
                  <div>
                    <PhoneNumberLogin
                      ref={ref => (this.phoneRef = ref)}
                      toggleKeyboard={this.handleKeyboardToggle}
                      setLoginType={this.handleLoginTypeChange}
                      activeKeyboard={this.state.activeKeyboard}
                      continueAsGuestUser={this.guestUser}
                      dynamicComponent={dynamicComponent ? true : false}
                      phoneNumberChange={this.phoneNumberChange}
                      phoneNumber={this.state.phoneNumber}
                      loginErrorMsg={this.state.loginErrorMsg}
                      showPhoneLoginModal={this.state.showPhoneLoginModal}
                      canHaveMultipleUsers={this.state.canHaveMultipleUsers}
                      showUsersChoiceModal={this.state.showUsersChoiceModal}
                      usersList={this.state.usersList}
                      selectedUserAccount={this.state.selectedUserAccount}
                      updateParentState={this.updatedParentState}
                      loginMemberCard={this.loginMemberCard}
                      handlePhoneNumberLogin={this.handlePhoneNumberLogin}
                      disableContinueBtn={this.disableContinueBtn}
                      useLoginModal={this.state.useLoginModal}
                    />
                  </div>
                );
              }
              if (module.loginType === 'email') {
                return (
                  <EmailLogin
                    ref={ref => (this.emailRef = ref)}
                    toggleKeyboard={this.handleKeyboardToggle}
                    setLoginType={this.handleLoginTypeChange}
                    activeKeyboard={this.state.activeKeyboard}
                    continueAsGuestUser={this.guestUser}
                    dynamicComponent={dynamicComponent ? true : false}
                    emailChange={this.emailChange}
                    email={this.state.email}
                    loginErrorMsg={this.state.loginErrorMsg}
                  />
                );
              }
              return null;
            })}
            {checkIfContinueBtnRequired ? (
              <div className="continue-btn">
                <a onClick={this.handlePhoneNumberLogin} href="javascript:;" className={`btn btnPrimary ${this.disableContinueBtn() ? 'disabled' : ''}`} title="SUBMIT">
                  CONTINUE
                </a>
              </div>
            ) : null}
            <div
              className={`procced-text ${this.props.hasOwnProperty('loginPageImage') && this.props.loginPageImage != '' ? 'has-image-pack' : ''} ${dynamicComponent ? ' dynamic-component-login' : ''}`}
            >
              <p>
                <span>OR</span>{' '}
                <a onClick={this.guestUser} href="javascript:;" title={window.constant.CONTINUE_AS_GUEST_BUTTON_TEXT ? window.constant.CONTINUE_AS_GUEST_BUTTON_TEXT : 'PROCEED AS A GUEST'}>
                  {window.constant.CONTINUE_AS_GUEST_BUTTON_TEXT ? window.constant.CONTINUE_AS_GUEST_BUTTON_TEXT : 'PROCEED AS A GUEST'}
                </a>
              </p>
            </div>
          </div>
        </section>
        {this.props.hasOwnProperty('loginPageImage') && this.props.loginPageImage != '' && (
          <div className="login-image-pack">
            <img src={this.props.loginPageImage} alt="login page banner" />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default index;
